import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-29a87979")

_pushScopeId("data-v-29a87979")
const _hoisted_1 = { class: "empty" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FileUpload = _resolveComponent("FileUpload")

  return (_ctx.isEditable)
    ? (_openBlock(), _createBlock(_component_FileUpload, {
        key: 0,
        id: "file",
        name: "file",
        multiple: true,
        maxFileSize: 2147483648,
        showUploadButton: false,
        ref: "fileUpload$",
        accept: _ctx.state.accept,
        url: _ctx.state.url,
        onProgress: _ctx.filesProgress,
        chooseLabel: "파일 선택"
      }, {
        empty: _withId(() => [
          _createVNode("p", _hoisted_1, _toDisplayString(_ctx.t("Drag and drop files to here to upload.")), 1)
        ]),
        _: 1
      }, 8, ["accept", "url", "onProgress"]))
    : _createCommentVNode("", true)
})